/* christina-facets-defer.js — Christina R7-A4 (kolekcja: odroczenie DOM filtrów)
   ---------------------------------------------------------------------------
   Co robi:
   - Zawartość ZAMKNIĘTEJ szuflady filtrów mobilnych (facet-sticky / FacetDrawerSticky)
     jest w <template id="CfStickyFacetsTpl"> i NIE tworzy elementów, inputów ani
     liczników, dopóki użytkownik jej nie otworzy.
   - Materializacja przy pierwszym realnym zamiarze: pointerdown / keydown / focusin
     na przycisku szuflady. Wstawianie przez insertAdjacentHTML, żeby customized
     built-ins (form is="facet-form", details is="accordion-details",
     select is="custom-select") zostały poprawnie ulepszone przez customElements.
   - Gdy URL zawiera aktywny filtr (?filter.…), materializacja idzie od razu
     (requestIdleCallback) — grupa jest zmaterializowana i rozwinięta zanim
     użytkownik zdąży otworzyć szufladę.
   - Formularz i parametry URL zostają natywne. Sidebar desktopowy (#FacetFiltersContainer)
     jest renderowany serwerowo BEZ ZMIAN — wejście z linku z filtrami działa tak samo.
   - Po filtracji theme (collection.js renderFilters) nie widzi grup ukrytych
     w <template>, więc synchronizację treści szuflady robimy tu, subskrypcją
     theme.pubsub facetUpdate — z pominięciem grupy, którą użytkownik właśnie kliknął.
   - Guard idempotencji + disconnect(): powtórny re-render sekcji nie rejestruje
     drugiego kompletu listenerów.
*/
(function () {
  'use strict';

  if (window.__christinaFacetsDefer) return;   // guard idempotencji
  window.__christinaFacetsDefer = true;

  var ID_TPL = 'CfStickyFacetsTpl';
  var ID_HOST = 'CfStickyFacetsHost';

  var lastResponse = null;   // ostatnia odpowiedź Section Rendering API
  var lastIndex = null;      // data-index grupy, w której użytkownik ostatnio klikał
  var wired = false;
  var unsubscribe = null;
  var trigger = null;

  var tpl = function () { return document.getElementById(ID_TPL); };
  var host = function () { return document.getElementById(ID_HOST); };
  var done = function () { var h = host(); return !!h && h.getAttribute('data-cf-materialized') === '1'; };

  function parse(text) {
    try { return new DOMParser().parseFromString(text, 'text/html'); } catch (e) { return null; }
  }

  /* ---------- materializacja ---------- */

  function materialize(reason) {
    var h = host(), t = tpl();
    if (!h || !t || done()) return false;

    var markup = null;
    if (lastResponse) {
      var doc = parse(lastResponse);
      var t2 = doc && doc.getElementById(ID_TPL);
      if (t2) markup = t2.innerHTML;
    }
    if (markup === null) markup = t.innerHTML;

    h.insertAdjacentHTML('beforeend', markup);
    h.setAttribute('data-cf-materialized', '1');
    unwire();

    // focus: nie przejmujemy focusu przy focusin (Tab) — szuflada sama go ustawia
    // po otwarciu. Przy klawiaturze upewniamy się tylko, że pierwszy nagłówek grupy
    // jest osiągalny (details/summary jest natywnie fokusowalny).
    document.dispatchEvent(new CustomEvent('christina:facets-materialized', {
      detail: { reason: reason || 'unknown' }
    }));
    return true;
  }

  /* ---------- wyzwalacze ---------- */

  function onIntent(e) {
    if (e.type === 'keydown') {
      var k = e.key;
      if (k !== 'Enter' && k !== ' ' && k !== 'Spacebar' && k !== 'Tab' && k !== 'ArrowDown') return;
    }
    materialize(e.type);
  }

  function wire() {
    if (wired) return;
    trigger = document.querySelector('facet-sticky');
    if (!trigger) return;
    trigger.addEventListener('pointerdown', onIntent, true);
    trigger.addEventListener('keydown', onIntent, true);
    trigger.addEventListener('focusin', onIntent, true);
    trigger.addEventListener('click', onIntent, true);
    wired = true;
  }

  function unwire() {
    if (!wired || !trigger) { wired = false; return; }
    trigger.removeEventListener('pointerdown', onIntent, true);
    trigger.removeEventListener('keydown', onIntent, true);
    trigger.removeEventListener('focusin', onIntent, true);
    trigger.removeEventListener('click', onIntent, true);
    wired = false;
  }

  /* ---------- synchronizacja po filtracji ---------- */

  function syncFromResponse(text) {
    if (!done()) return;
    var doc = parse(text);
    var t = doc && doc.getElementById(ID_TPL);
    if (!t) return;
    var frag = t.content;
    if (!frag) { frag = document.createElement('div'); frag.innerHTML = t.innerHTML; }
    var nodes = frag.querySelectorAll('[data-filter]');
    for (var i = 0; i < nodes.length; i++) {
      var src = nodes[i];
      var idx = src.getAttribute('data-index');
      if (!idx || idx === lastIndex) continue;          // nie nadpisuj grupy klikniętej przez użytkownika
      var live = document.querySelector('[data-filter][data-index="' + idx + '"]');
      if (!live) continue;
      if (live.tagName === 'DETAILS') {
        var a = live.querySelector('summary + *'), b = src.querySelector('summary + *');
        if (a && b) a.innerHTML = b.innerHTML;
      } else {
        live.innerHTML = src.innerHTML;
      }
    }
  }

  function onChangeCapture(e) {
    var el = e.target;
    var grp = el && el.closest ? el.closest('[data-filter]') : null;
    lastIndex = grp ? grp.getAttribute('data-index') : null;
  }

  function subscribe() {
    if (unsubscribe) return true;                      // guard: jedna subskrypcja
    var p = window.theme && window.theme.pubsub;
    if (!p || !p.subscribe || !p.PUB_SUB_EVENTS) return false;
    unsubscribe = p.subscribe(p.PUB_SUB_EVENTS.facetUpdate, function (d) {
      if (!d || !d.responseText) return;
      lastResponse = d.responseText;
      syncFromResponse(d.responseText);
    }) || function () { };
    return true;
  }

  /* ---------- start ---------- */

  function start() {
    if (!tpl() || !host()) return;
    wire();
    if (!subscribe()) {
      // theme.js ma defer — próbujemy jeszcze raz po load
      window.addEventListener('load', subscribe, { once: true });
    }
    if (/[?&]filter\./.test(window.location.search)) {
      var go = function () { materialize('url-filter'); };
      if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 1500 });
      else setTimeout(go, 0);
    }
  }

  document.addEventListener('change', onChangeCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Re-render sekcji w edytorze motywu: przypinamy się do nowego DOM-u,
  // ale bez dublowania listenerów (unwire + wire, jedna subskrypcja).
  document.addEventListener('shopify:section:load', function () {
    unwire();
    var h = host();
    if (h && h.getAttribute('data-cf-materialized') !== '1') { wired = false; wire(); }
  });
})();
